import emailRegex from "../../emailRegex";
import textSchema from "./text";

const emailSchema = textSchema
  .matches(emailRegex);

export default emailSchema;